<template>
    <div class="report-info">
        <!-- 1、八字部分 -->
        <div class="report-info-eight-word dsp-flex">
            <div class="report-info-column-item item-one">
                <div class="report-info-ci-one"></div>
                <div class="report-info-ci-two ci-two-label">
                    <span class="report-info-ci-label">天<br />干</span>
                </div>
                <div class="report-info-ci-two ci-two-label">
                    <span class="report-info-ci-label">地<br />支</span>
                </div>
            </div>
            <div class="report-info-column-item" v-for="(baziData, index) in reportBaziData">
                <div class="report-info-ci-one">
                    <p>{{ baziData.title }}</p>
                    <p>{{ baziData.solar }}</p>
                    <p>{{ baziData.lunar }}</p>
                </div>
                <div class="report-info-ci-three" :class="'word-'+baziData.tg.propXingEn">
                    <div class="report-info-ci-big">{{ baziData.tg.text }}</div>
                    <div class="report-info-ci-hide">
                        {{ baziData.tg.propXing }}
                        <i v-if="index == 2" class="iconbg icon-sex" v-bind:class="{'icon-male': detailInfo.sex == '男' || detailInfo.sex == 0, 'icon-female': detailInfo.sex == '女' || detailInfo.sex == 1}"></i>
                    </div>
                </div>
                <div class="report-info-ci-three" :class="'word-'+baziData.dz.propXingEn">
                    <div class="report-info-ci-big">{{ baziData.dz.text }}</div>
                    <div class="report-info-ci-hide">{{ baziData.dz.propXing }}</div>
                </div>
            </div>
        </div>

        <!-- 2、八字介绍部分 -->
        <div class="report-info-eight-word-intro">
            <p>以上是根据生日时间排列的生辰八字，其中上面一行是天干，下面一行是地支，8个字中以日干代表生日主人(即上图中标有性别图标的字),每个字所带的颜色或者后面标注了五行的即为五行属性。</p>
        </div>

        <!-- 3、五行能量部分 -->
        <div class="report-info-eight-word-content">
            <div class="report-info-ewc-content" v-if="reportBaziData.length > 0 && reportBaziData[2]">
                <p class="report-info-ewc-title"><span class="title">此生辰八字的主人是</span><span class="title" :class="'word-'+reportBaziData[2].tg.propXingEn">{{ reportBaziData[2].tg.text+reportBaziData[2].tg.propXing }}</span><span class="title">命</span></p>
                <p class="report-info-ewc-intro">注意民间有用年柱纳音来测算是什么命的，从大数据角度来说准确性有限，数千年以日干为主人更准。</p>
            </div>
            <div class="report-info-ewc-content" v-if="reportStrongInfo">
                <p class="report-info-ewc-title"><span class="title">身强身弱:</span><span>{{ reportStrongInfo.strong ? '身强' : '身弱' }}</span></p>
                <p class="report-info-ewc-intro">身强身弱并无绝对好坏，都有典型成功人士。</p>
            </div>
            <div class="report-info-ewc-content" v-if="reportStrongInfo">
                <p class="report-info-ewc-title"><span class="title">五行能量大小分布</span></p>
                <div class="report-info-ewc-data-content">
                    <report-energy-item :itemData="reportStrongInfo.gold"></report-energy-item>
                    <report-energy-item :itemData="reportStrongInfo.wood"></report-energy-item>
                    <report-energy-item :itemData="reportStrongInfo.water"></report-energy-item>
                    <report-energy-item :itemData="reportStrongInfo.fire"></report-energy-item>
                    <report-energy-item :itemData="reportStrongInfo.soil"></report-energy-item>
                </div>
            </div>
            <div class="report-info-ewc-content">
                <div class="report-info-ewc-title clearfix">
                    <div class="ewc-title-box"><span class="title">五行喜忌：</span></div>
                    <div class="title-content">
                        喜<span v-for="goodData in reportStrongInfo.goodWx" :class="'word-'+goodData.wxEn">{{ goodData.wxText }}</span>，忌<span v-for="badData in reportStrongInfo.badWx" :class="'word-'+badData.wxEn">{{ badData.wxText }}</span>
                    </div>
                </div>
                <div class="report-info-ewc-title">
                    <div class="ewc-title-box"><span class="title">喜用颜色：</span></div>
                    <div class="title-content">{{ reportStrongInfo.goodColour.join('、') }}</div>
                </div>
                <div class="report-info-ewc-title">
                    <div class="ewc-title-box"><span class="title">忌用颜色：</span></div>
                    <div class="title-content">{{ reportStrongInfo.badColour.join('、') }}</div>
                </div>
                <div class="report-info-ewc-title">
                    <div class="ewc-title-box"><span class="title">喜用生肖：</span></div>
                    <div class="title-content">{{ reportStrongInfo.goodAni.join('、') }}</div>
                </div>
                <div class="report-info-ewc-title">
                    <div class="ewc-title-box"><span class="title">易冲生肖：</span></div>
                    <div class="title-content">{{ reportStrongInfo.badAni[0] }}(相冲)</div>
                </div>
            </div>
        </div>

        <!-- 4、八字介绍部分 -->
        <div class="report-info-eight-word-intro">
            <p>常识误区：五行缺失，但不代表需要加强，而代表该五行对应的一些天赋能力的缺失，从根本上需要从后天练习来补充。通过佩戴相关颜色或手饰虽然治标不治本但也能起到一定的加分加成作用，考虑到配合运势的助力，建议大家优先选择所喜五行，而不是所缺的五行。</p>
        </div>
    </div>
</template>

<script>
import ReportEnergyItem from '../common/ReportEnergyItem.vue';
export default {
    name: 'ReportInfo',
    components: { ReportEnergyItem },
    computed: {
        detailInfo() {
            return this.$store.state.strong.detailInfo;
        },
        reportData() {
            return this.$store.state.strong.reportData;
        },
        reportAIData() {
            return this.$store.state.strong.reportAIData;
        },
        reportBaziData() {
            return this.$store.state.strong.reportBaziData;
        },
        reportStrongInfo() {
            return this.$store.state.strong.reportStrongInfo;
        }
    },
    data() {
        return {

        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>
